import type { CSSProperties, FC, ReactNode } from 'react'

import { Check, Mail } from 'lucide-react'
import { PHOTO } from '@/constants/media'

/** An inspection in progress, the notice that started it, and the answer that ends the worry. */
export const HmsHeroVisual: FC = (): ReactNode => (
    <div className='load-fade relative mx-auto w-full max-w-[38rem]' style={{ '--load-delay': '0.4s' } as CSSProperties}>
        <div className='relative aspect-square overflow-hidden bg-night-raised'>
            <img
                src={PHOTO.hmsInspection}
                alt='Kontrollør i refleksvest og håndverker i varselklær går gjennom dokumentasjon på byggeplassen'
                fetchPriority='high'
                decoding='async'
                className='size-full object-cover'
            />
            <div className='absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-night-deep/60' />
            <p className='t-label absolute bottom-5 left-5 text-paper'>Tilsyn · Byggeplass</p>
        </div>

        <div className='hms-notice absolute -top-6 left-4 right-10 bg-paper p-4 text-night shadow-2xl md:-left-12 md:right-auto md:w-[21rem]'>
            <p className='flex items-center gap-3'>
                <span className='flex size-9 shrink-0 items-center justify-center bg-night text-paper' aria-hidden='true'>
                    <Mail className='size-4' />
                </span>
                <span>
                    <span className='block text-sm font-semibold'>Varsel om tilsyn</span>
                    <span className='block text-xs text-slate'>Tilsyn på byggeplassen torsdag kl. 09.00</span>
                </span>
            </p>
        </div>

        <div className='hms-reply absolute -bottom-8 right-4 flex items-center gap-3 bg-lime px-4 py-3 text-night shadow-2xl md:-right-8'>
            <span className='flex size-7 shrink-0 items-center justify-center bg-night text-lime' aria-hidden='true'>
                <Check className='size-4' strokeWidth={3} />
            </span>
            <span className='text-sm'>
                <span className='block font-semibold'>Alt ligger klart i Svenn.</span>
                <span className='block text-xs text-night/70'>Håndbok, rutiner, SJA og avvik</span>
            </span>
        </div>
    </div>
)
